// เมนู action ที่ถูกย้ายไปแขวนใต้ <body> อยู่ตอนนี้ (ปกติมีได้ตัวเดียว
// เพราะ Bootstrap ปิดตัวเก่าก่อนเปิดตัวใหม่ แต่เก็บเป็น Set ไว้กันพลาด)
// ต้องอยู่นอก initDropdownHelper() เพราะ closeActionDropdowns() ต้องเห็นด้วย
const relocatedMenus = new Set(); // { btn, menu, parent, nextSibling }

// คืน menu กลับที่เดิมใต้ row + ล้าง inline style ที่ตั้งไว้ตอนเปิด
// ถ้า parent เดิมหายไปแล้ว (Vue ลบ row / เปลี่ยนหน้า) ให้ทิ้ง menu ไปเลย
// ไม่งั้นมันจะค้างอยู่ใน <body> ข้ามหน้า
function restoreMenu(entry) {
  const { menu, parent, nextSibling } = entry;
  relocatedMenus.delete(entry);

  menu.style.position = '';
  menu.style.top = '';
  menu.style.right = '';
  menu.style.left = '';
  menu.style.transform = '';
  menu.style.visibility = '';

  if (menu.parentNode !== document.body) return;

  if (!parent || !parent.isConnected) {
    menu.remove();
    return;
  }

  if (nextSibling && nextSibling.parentNode === parent) {
    parent.insertBefore(menu, nextSibling);
  } else {
    parent.appendChild(menu);
  }
}

/* ปิด action dropdown ที่ค้างอยู่ทั้งหมด — เรียกตอนเปลี่ยน route (main.js)

   เคส: กดปุ่ม ... ในตารางแล้วกดเมนูฝั่งซ้ายทันที Vue unmount หน้าเดิม
   (ทำให้ปุ่ม toggle หลุดจาก DOM) ก่อนที่ Bootstrap จะได้รัน clearMenus
   ตัว clearMenus หาปุ่ม `[data-bs-toggle="dropdown"].show` ไม่เจอแล้ว เลยไม่ปิดให้
   menu ที่เราย้ายไปไว้ใต้ <body> จึงลอยค้างตามไปหน้าถัดไป */
export function closeActionDropdowns() {
  for (const entry of Array.from(relocatedMenus)) {
    const { btn, menu } = entry;

    // ปุ่มยังอยู่ → ให้ Bootstrap ปิดตามปกติ (hidden.bs.dropdown จะ restore เอง)
    if (btn.isConnected && window.bootstrap?.Dropdown) {
      const instance = window.bootstrap.Dropdown.getInstance(btn);
      if (instance) {
        instance.hide();
        continue;
      }
    }

    // ปุ่มหายไปแล้ว → ไม่มีใครยิง hidden.bs.dropdown ให้ ต้องเก็บกวาดเอง
    btn.classList.remove('show');
    btn.setAttribute('aria-expanded', 'false');
    menu.classList.remove('show');
    restoreMenu(entry);
  }
}

export function initDropdownHelper() {
  /* =======================================================
     จัดตำแหน่ง Action Dropdown ให้ลอยตัว ไม่ถูกหนีบด้วย overflow
     ของตาราง — ใช้ position: fixed คำนวณจาก getBoundingClientRect
     ของปุ่ม ใช้ทั้ง PC และ mobile

     สำคัญ: ต้องย้าย menu ไปไว้ใต้ <body> ตอนเปิด เพราะ mobile browser
     (WebKit/iOS) มี bug clip position:fixed เมื่อ ancestor มี overflow
     ทำให้ menu โดน clip บางส่วนหายไป
  ======================================================= */
  const menuOriginByBtn = new WeakMap(); // btn -> { btn, menu, parent, nextSibling }
  let lastShowAt = 0; // เวลาที่เพิ่งเปิด dropdown ล่าสุด (กัน scroll listener ปิดเอง)

  document.addEventListener('show.bs.dropdown', function (e) {
    const btn = e.target;
    if (!btn.classList || !btn.classList.contains('action-btn')) return;

    let entry = menuOriginByBtn.get(btn);
    let menu;
    if (!entry) {
      menu = btn.nextElementSibling;
      if (!menu || !menu.classList.contains('dropdown-menu')) return;
      entry = {
        btn,
        menu,
        parent: menu.parentNode,
        nextSibling: menu.nextSibling
      };
      menuOriginByBtn.set(btn, entry);
    } else {
      menu = entry.menu;
    }

    const rect = btn.getBoundingClientRect();

    // Pre-position ก่อนย้ายไป body เพื่อไม่ให้ menu โผล่ที่มุมบนซ้ายแวบนึง
    menu.style.position = 'fixed';
    menu.style.right = `${window.innerWidth - rect.right}px`;
    menu.style.left = 'auto';
    menu.style.top = `${rect.bottom + 4}px`;
    menu.style.transform = 'none';
    menu.style.visibility = 'hidden'; // ซ่อนไว้จนกว่าจะวัดความสูงเสร็จ

    // ย้ายไป body หลุดจาก stacking context และ overflow ทั้งหมด
    if (menu.parentNode !== document.body) {
      document.body.appendChild(menu);
    }
    relocatedMenus.add(entry);

    lastShowAt = performance.now();

    // วัดความสูงจริงหลัง Bootstrap ใส่ .show แล้ว flip-up ถ้าจำเป็น
    requestAnimationFrame(() => {
      const menuHeight = menu.offsetHeight || 0;
      const spaceBelow = window.innerHeight - rect.bottom;

      if (spaceBelow < menuHeight && rect.top > spaceBelow) {
        menu.style.top = `${Math.max(8, rect.top - menuHeight - 4)}px`;
      }
      menu.style.visibility = '';
    });
  });

  // ตอนปิด dropdown: ย้าย menu กลับที่เดิม กัน Vue re-render แล้ว menu หาย
  document.addEventListener('hidden.bs.dropdown', function (e) {
    const btn = e.target;
    if (!btn.classList || !btn.classList.contains('action-btn')) return;

    const entry = menuOriginByBtn.get(btn);
    if (!entry) return;

    restoreMenu(entry);
  });

  // ปิด dropdown อัตโนมัติเมื่อ scroll หน้าเว็บ — แต่กันการปิดตัวเอง
  // โดย ignore scroll event ที่เกิดภายใน 250ms หลังเพิ่งเปิด
  // (browser อาจ scroll นิดๆ ตอน focus/layout shift)
  window.addEventListener('scroll', function () {
    if (performance.now() - lastShowAt < 250) return;
    document.body.click();
  }, true);
}
